module.exports = __webpack_public_path__ + "img/Group3.5468b886.png";